<!-- 商品详情页 -->
<template>
	<div v-if="currentInfo">
		<van-nav-bar
		  left-arrow
		  right-text="去活动页"
		   @click-right="goActivityInfo"
		  @click-left="onClickLeft"
		  fixed
		/>
		
		<!-- 轮播图 -->
<!-- 		<van-swipe :autoplay="3000">
		  <van-swipe-item  v-for="(image,index) in currentInfo.image" :key="index">
			<van-image		 
			  fit="contain"
			  :src="image"
			  lazy-load
			  style="vertical-align: middle;"
			>
				<template v-slot:loading>
					<van-loading type="spinner" size="20" />
				</template>
			</van-image>
		  </van-swipe-item>
		</van-swipe> -->
		<div style="position: relative;width: 100%;padding-top:100%;margin-top: 50px;">
			<van-image
			  fit="contain"
			  :src="currentInfo.image[0]"
			  lazy-load
			  style="vertical-align: middle; position: absolute;left: 0; bottom: 0;"
			  v-if="currentInfo.image"
			>
				<template v-slot:loading>
					<van-loading type="spinner" size="20" />
				</template>
			</van-image>
			
		</div>
		
		
		
		<!-- 价格和分享 -->
		<van-row class="current-title" >
			<van-col class="current-price" v-if="currentInfo.vip_price">￥{{(currentInfo.vip_price*1).toFixed(2)}}</van-col>
			<van-col class="van-multi-ellipsis--l2" style="text-align: left;">{{currentInfo.name}}</van-col>
		</van-row>
		<div class="fgline"></div>
		<div style="padding: 20px; ">
			<div class="currentInfo-info" v-if="currentInfo.limit_num" style="color: red;">
				<div style="margin-right: 5px;">每人限购数量:</div>
				<div>{{currentInfo.limit_num}}{{currentInfo.unit_name}}</div>
			</div>
			<div class="currentInfo-info" v-if="currentInfo.product_place">
				<div style="margin-right: 5px;">产地:</div>
				<div>{{currentInfo.product_place}}</div>
			</div>
			<div class="currentInfo-info" v-if="currentInfo.size">
				<div style="margin-right: 5px;">规格:</div>
				<div>{{currentInfo.size}}/{{currentInfo.unit_name}}</div>
			</div>
			<!-- <div class="currentInfo-info">
				<div style="margin-right: 5px;">保质期:</div>
				<div>{{currentInfo.shelf_life}}</div>
			</div> -->
			<div class="currentInfo-info" v-if="currentInfo.is_no_stock == 2 && currentInfo.stock> 0&&currentInfo.stock<10">
				<div style="margin-right: 5px;">库存:</div>
				<div>仅剩{{currentInfo.stock}}件</div>
			</div>
		</div>
		<div class="fgline"></div>	
		<div>
			<div style="font-size: 20px;font-weight: 550;padding: 20px;">图文详情</div>
			<div class="info-box">
				<van-image
				  v-for="(image,index) in currentInfo.image " :key="index"
				  fit="contain"
				  :src="image"
				  lazy-load
				  style="vertical-align: middle;display: block;"
				>
					<template v-slot:loading>
						<van-loading type="spinner" size="20" />
					</template>
				</van-image>
			</div>
		</div>
		<!-- <van-divider style="margin-bottom: 50px;">到底了</van-divider> -->
		<!-- 详情导航 -->
		<van-goods-action style="z-index: 999;">
		  <van-goods-action-icon icon="wap-home-o" text="首页"  @click="goIndex"/>
		  <van-goods-action-icon icon="cart-o" text="购物车" :badge="cartTotalNum?cartTotalNum:''" @click="gocart"/>
		    <div style="width: 100%;padding-right: 10px;box-sizing: border-box;">
				<div>						
					<van-goods-action-button  style="background-color: #00C719; color: #fff; " disabled text="已售罄" v-if="currentInfo.stock<=0 && currentInfo.is_no_stock==2"/>
					<van-goods-action-button  style="background-color: #00C719; color: #fff; " text="加入购物车" @click="addCart(currentInfo)" v-else />
				</div>
				
				
		  </div>
		  
		</van-goods-action>
	</div>
</template>

<script>
import {mapState,mapActions} from 'vuex'	
import wx from "weixin-js-sdk";
	export default{
		name:"productInfo",
		data(){
			return{
				currentInfo:{},
				canBack:false,
			}
		},
		computed:{
			...mapState(['cartTotalNum',]),
		},
		methods:{
			addCart(params){
				// if(!this.token){
				//   localStorage.setItem("preRoute", this.$router.currentRoute.fullPath);
				//   localStorage.setItem("isPreRoute", true);
				// }
				this.$store.dispatch('addCartAsync',params)
			},
			onClickLeft() {
				if(this.canBack) {
					this.$router.go(-1)
					return
				}
				else{
					this.goActivityInfo()
				}
								   
			    },	
			goActivityInfo(){				
				this.$router.push({
					path:'/activityInfo',
					query:{
						id:this.currentInfo.activity_id
					}
				})
			},
			gocart(){
				this.$router.push('/cart')
			},
			//回首页
			goIndex(){
				this.$router.push('/')
			},
			//获取商品详情
			// getActivityItem(id){
			// 	this.request.postURL('/api/activity/getActivityItem',{
			// 		id:id
			// 	}).then((res)=>{	
			// 		this.currentInfo=res.data.data.goods_detail;
			// 		this.weixinShare()
			// 	}).catch( (err) =>{
			// 	   console.log(err)
			// 	  });
			// },
			//获取商品详情
		async	getActivityItem(id){
			let res = await this.request.postURL('/api/activity/getActivityItem',{
					id:id
				})
				this.currentInfo=res.data.data.goods_detail;
				await this.weixinShare()
				
				
			},
			//微信分享
			weixinShare(){
				
				const url = window.location.href.split("#")[0]; //获取当前的url
				this.request.postURL("/api/activity/shareGroupH5",{
						id:0,
						url:url,
				}).then(res=>{	
						var size = this.currentInfo.size ? this.currentInfo.size:''
						size+='/'
						var option={
							shareTitle:this.currentInfo.name,
							shareUrl:window.location.href,
							shareDesc:"规格:"+size+this.currentInfo.unit_name+'\r\n价格:￥'+ this.currentInfo.vip_price,
							shareImg:this.currentInfo.image[0],
						}
					wx.config({
						debug: false, //是否开启debug
						appId: res.data.data.appid,//你的appid
						timestamp: res.data.data.timestamp, //时间戳
						nonceStr: res.data.data.noncestr,//随机字符串
						signature: res.data.data.signature,//秘钥（秘钥生成规则请看我另一篇文章（php获取微信AccessToken，生成秘钥））
						jsApiList: [ //请求的api接口列表
								'updateAppMessageShareData',
								'updateTimelineShareData',
								'onMenuShareAppMessage',
								'onMenuShareTimeline',
								"getLocation"
						],		
					});
					wx.ready(function () { //如果wx.config配置正常，会自动走此处			
						wx.updateAppMessageShareData({
							title: option.shareTitle,//分享的标题
							desc: option.shareDesc,//分享的简介
							link: option.shareUrl,//分享的url
							imgUrl: option.shareImg,//分享的图片
							success:function(){
								
							},
							fail:function(){
								// alert("分享失败")
							}
						});	
						//分享朋友圈
						wx.updateTimelineShareData({
						    title: option.shareTitle,//分享的标题
						    desc: option.shareDesc,//分享的简介
						    link: option.shareUrl,//分享的url
						    imgUrl: option.shareImg,//分享的图片
							success:function(){
								
							},
							fail:function(){
								// alert("分享失败")
							}
						});				
					});
					
					wx.error(function (res) { //如果wx.config配置失败,会走到此处
						
					})
				});
			}
			// },
		},
		 mounted() { 
			 // if(this.currentInfo){
				//  this.weixinShare()
			 // }	
		},
		created() {
			this.getActivityItem(this.$route.query.id)
		},
		beforeRouteEnter (to, from, next) {
		  next(vm => {
			vm.canBack=false;
			if(from.path == "/activityInfo") {
				 vm.canBack=true
			}
		  })
		}
	}
	
</script>

<style>
	.info-box{
		margin-bottom: 50px;
	}
	.current-title{
		display: flex;
		flex-direction: column;
		padding: 10px 20px;
		align-items: flex-start;
		font-size: 20px;
		font-weight: 550;
	}
	.current-price{
		color:red;
	}
	.currentInfo-info{
		display: flex;
		font-size: 14px;
	}
	.fgline{
		width: 100%;
		height: 10px;
		background-color: #F5F5F5;
	}
</style>
